module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp23_7016.99125e47.png";